export default String.raw`

<div class="eshop__table-container products div-table-js">
	<table>
		<thead>
			<div class="products-table-header-js">
				<tr class="products-table-header-container-js">
					<td class="id number-column-js"></td>
					<th scope="col">{{ translations.Product }}</th>
					{% unless include == 'wm' -%}
						<th scope="col" class="price-like-column-js">
							{{ translations.Price }}
						</th>
						<th scope="col" class="percent-column-js">
							{{ translations.Vat }}
						</th>
					{% endunless -%}
					<th scope="col" class="amount-stepper-column-js">
						{{ translations.Quantity }}
					</th>
					{% unless include == 'wm' -%}
						{% if settings.discountsPresentationOnOrderPositions == 'yes' %}
							<th scope="col" class="percent-column-js" rv-if="AnyDiscountExists">
								{{ translations.Discount }}
							</th>
						{% endif -%}
						<th scope="col" class="price-like-column-js">
							{{ translations.Value }} {{ translations.Netto | Downcase }}
						</th>
						<th scope="col" class="price-like-column-js">
							{{ translations.Value }} {{ translations.Brutto | Downcase }}
						</th>
						<th scope="col" class="currency-column-js">
							{{ translations.Currency }}
						</th>
					{% endunless -%}
					<th scope="col" class="options options-column-js">
						<button aria-label="{{translations.Options}}" class="pure-button open-dropdown-js">
							<svg width="24" height="24" style="transform: rotate(90deg);">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#ellipsis-h-{{settings.iconStyle}}"></use>
							</svg>
						</button>
						<div class="dropdown dropdown-js hidden-js">
							<button class="pure-button roll-out-js">{{translations.RollOutEverything}}</button>
							<button class="pure-button roll-up-js">{{translations.RollUpEverything}}</button>
						</div>
					</th>
				</tr>
			</div>
		</thead>
		<tbody>
			<div class="expandable-mechanism-container-js" rv-each-product="Result">
			<tr class="row expandable-mechanism-container-js" rv-each-product="Result">
				<td class="id options-column-js">{ product.No }</td>
				<td>
					<div class="product-cell name-and-code-js">
						<div class="product-info">
							<span class="product-name">{ product.NameNoHtml }</span>
							{% if config.Products.ShowCode -%}
								<p class="product-code">{ product.Code }</p>
							{% endif -%}
							<div class="expandable-js" rv-if="product.DescriptionOrAttributesExists">
								<span class="product-id-js hidden-js">{product.DocumentElementId}</span>
								<ul class="description" rv-if="product.DescriptionExists"></ul>
							</div>
						</div>
					</div>
				</td>
				{% unless include == 'wm' -%}
					<td class="price-like-column-js">
						<span rv-class-netto-price="product.NettoPrices" rv-if="product.PriceExists">
							{ product.Price | price product.Precision }
						</span>
						<span class="ribbon free" rv-unless="product.PriceExists">{{ translations.Free }}</span>
					</td>
					<td class="percent-column-js"> { product.VAT } %</td>
				{% endunless -%}
				<td class="amount-stepper-column-js">
					<span>{ product.Quantity }</span>
					<span>{ product.Unit }</span>
				</td>
				{% unless include == 'wm' -%}
					{% if settings.discountsPresentationOnOrderPositions == 'yes' -%}
						<td class="percent-column-js" rv-if="AnyDiscountExists">
							<span rv-if="product.DiscountExists">{ product.Discount | price product.Precision } %</span>
						</td>
					{% endif -%}
					<td class="price-like-column-js">
						<span class="netto-price">{ product.SubtotalValue | price } </span>
					</td>
					<td class="price-like-column-js">
						{ product.TotalValue | price }
					</td>
					<td class="currency-column-js">
						{ product.Currency }
					</td>
				{% endunless -%}
				<td class="options options-column-js">
					<button aria-label="{{ translations.ShowDetails }}" rv-if="product.AttributesExist" class="pure-button expand-data-js change-arrow-title-js dropdown-arrow" title="{{ translations.ShowDetails }}">
						<svg height="16" width="16" class="icon rotate-down">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
						</svg>
					</button>
				</td>
			</tr>
		</tbody>
	</table>
	<div rv-if="FewPages">
		<div>
			{% include 'partials/customer-profile/pagination.html' -%}
		</div>
	</div>
</div>

`